import React, { useState } from 'react';
import axios from 'axios';
import Navbar from '../Components/Navbar';
import icon1 from '../Assets/bxs_phone-call.png';
import icon2 from '../Assets/Vector-1.png';
import icon3 from '../Assets/place.png';
import { FaLinkedin, FaTwitter, FaInstagram } from 'react-icons/fa';
import Footer from '../Components/Footer';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Contact() {
  // State variables for form inputs and submission status
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNo: '',
    subject: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.firstName || !formData.email || !formData.message) {
      toast.error('Please fill in all required fields');
      return;
    }
    
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error('Please enter a valid email address');
      return;
    }
    
    // Validate phone number if provided
    if (formData.phoneNo && !/^\d{10}$/.test(formData.phoneNo)) {
      toast.error('Please enter a valid 10-digit phone number or leave it blank');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // Prepare email content
      const subject = formData.subject || `Contact Form Submission from ${formData.firstName} ${formData.lastName}`;
      let body = `Name: ${formData.firstName} ${formData.lastName}\n`;
      body += `Email: ${formData.email}\n`;
      if (formData.phoneNo) body += `Phone: ${formData.phoneNo}\n`;
      if (formData.subject) body += `Subject: ${formData.subject}\n`;
      body += `\nMessage:\n${formData.message}`;
      
      // Create mailto link with encoded subject and body
      const mailtoLink = `mailto:info@onexinfinity.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      
      // Open default email client
      window.location.href = mailtoLink;
      
      // Show success message
      toast.success('Your email client is opening with a pre-filled message. Please send it to contact us.');
      
      // Reset form
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phoneNo: '',
        subject: '',
        message: ''
      });
      
    } catch (error) {
      console.error('Error preparing email:', error);
      toast.error('Failed to open email client. Please try again or email us directly at info@onexinfinity.com');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Navbar/>
      <div className='banner banner7'>
        <h2 data-aos="fade-right">Contact Us</h2>
        <p data-aos="fade-right">Home / Contact Us</p>
      </div>
      <div className='new-contact'>
        <div className='new-contact-left'>
          <h2>Get in Touch</h2>
          <p>We'd love to hear from you! Reach out for collaborations, speaking engagements, or just to say hello.</p>
          <br/>
          
          <br/>

          <div className='new-contact-icons'>
            <div className='new-contact-icon'>
              <img src={icon2} alt="Email"/>
            </div>
            <div>
              <h4>Email</h4>
              <p>info@onexinfinity.com</p>
            </div>
          </div>
          <br/>

          <div className='new-contact-icons'>
            <div className='new-contact-icon'>
              <img src={icon3} alt="Bangalore Office"/>
            </div>
            <div>
              <h4>Bangalore Office</h4>
              <p>RMZ Latitude, 10th Floor, Bellary Road,<br/>Hebbal, Bangalore - 560024</p>
            </div>
          </div>
          <br/>
          <div className='new-contact-icons'>
            <div className='new-contact-icon'>
              <img src={icon3} alt="Mumbai Office"/>
            </div>
            <div>
              <h4>Mumbai Office</h4>
              <p>Enam Sambhav, C - 20, G Block Rd,<br/>G Block BKC, Bandra Kurla Complex,<br/>Bandra East, Mumbai, Maharashtra 400051</p>
            </div>
          </div>
          <br/>

          <div className='social-links'>
            <a href="https://linkedin.com/company/onexinfinity" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="social-icon" />
            </a>
            <a href="https://twitter.com/onexinfinity" target="_blank" rel="noopener noreferrer">
              <FaTwitter className="social-icon" />
            </a>
            <a href="https://instagram.com/onexinfinity" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="social-icon" />
            </a>
          </div>
        </div>
        <div className='new-contact-right'>
          <form className='new-contact-form' onSubmit={handleSubmit}>
            <div className='contactips-div'>
              <div className='contactips'>
                <label>First Name *</label>
                <input 
                  name='firstName' 
                  value={formData.firstName} 
                  onChange={handleChange} 
                  placeholder='Enter your first name'
                  required 
                />
              </div>
              <div className='contactips'>
                <label>Last Name *</label>
                <input 
                  name='lastName' 
                  value={formData.lastName} 
                  onChange={handleChange} 
                  placeholder='Enter your last name'
                  required 
                />
              </div>
            </div>
            
            <div className='contactips-div'>
              <div className='contactips'>
                <label>Email *</label>
                <input 
                  type='email' 
                  name='email' 
                  value={formData.email} 
                  onChange={handleChange} 
                  placeholder='your.email@example.com'
                  required 
                />
              </div>
              <div className='contactips'>
                <label>Phone Number</label>
                <input 
                  name='phoneNo' 
                  value={formData.phoneNo} 
                  onChange={handleChange} 
                  placeholder='Enter your phone number'
                  pattern='[0-9]{10}'
                  title='Please enter a 10-digit phone number'
                />
              </div>
            </div>
            
            <div className='contactips-div'>
              <div className='contactips' style={{width: '100%'}}>
                <label>Subject *</label>
                <input 
                  name='subject' 
                  value={formData.subject} 
                  onChange={handleChange} 
                  placeholder='What would you like to discuss?'
                  required 
                />
              </div>
            </div>
            
            <div className='contactips-div'>
              <div className='contactips' style={{width: '100%'}}>
                <label>Your Message *</label>
                <textarea 
                  name='message' 
                  value={formData.message} 
                  onChange={handleChange} 
                  placeholder='Type your message here...'
                  rows='5'
                  required
                />
              </div>
            </div>
            
            <button type='submit' disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </button>
            <br />
            <br />
          </form>
        </div>
      </div>
      <ToastContainer 
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Footer/>
    </>
  )
}

export default Contact